export const ACCESS_TOKEN_NAME = 'accessToken';
export const REFRESH_TOKEN_NAME = 'refreshToken';
export const IMPERSONATOR_ACCESS_TOKEN_NAME = 'impersonatorAccessToken';
export const IMPERSONATOR_REFRESH_TOKEN_NAME = 'impersonatorRefreshToken';
export const DEFAULT_PAGE_SIZE = 50;
export const TARIFFS_ANCHOR_ID = 'tariffs-list';
export const AUTO_SELECT_ID = 'auto-select';
export const TAG_LABEL_MAX = 49;
